module.exports = __webpack_public_path__ + "img/img10.f4c676fb.jpg";